import {
  Billing20201105BillingAccountStatus,
  BillingAccountOnDemandStatus,
  Billing20201105ContractStatus,
} from '@clients/cloud-billing';

// original low balance amount when default trial credits is maximum $50.00
export const BILLING_LOW_BALANCE = 10.0;

// updated low balance amount when default trial credits is maximum $500.00 on release of Flex 2
export const BILLING_LOW_BALANCE_UPDATED = 100.0;

export const BILLING_ACCOUNT_STATUS = Object.freeze({
  ACTIVE: Billing20201105BillingAccountStatus.ACTIVE,
  DELETING: Billing20201105BillingAccountStatus.DELETING,
  DELINQUENT: Billing20201105BillingAccountStatus.DELINQUENT,
  INCOMPLETE: Billing20201105BillingAccountStatus.INCOMPLETE,
  TRIAL: Billing20201105BillingAccountStatus.TRIAL,
});

export const BILLING_ON_DEMAND_STATUS = Object.freeze({
  ACTIVE: BillingAccountOnDemandStatus.ACTIVE,
  DELETING: BillingAccountOnDemandStatus.DELETING,
  INVALID: BillingAccountOnDemandStatus.INVALID,
  UNSET: BillingAccountOnDemandStatus.UNSET,
});

export const BILLING_ACCOUNT_STANDINGS = Object.freeze({
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  OVERDUE: 'OVERDUE',
  GOOD_STANDING: 'GOOD_STANDING',
  OPEN: 'OPEN',
  PAID: 'PAID',
  ROLLED_OVER: 'ROLLED_OVER',
  TRIAL: 'TRIAL',
  UNKNOWN: 'UNKNOWN', // This is UI-only.
  UPCOMING: 'UPCOMING',
});

// Must match ContractStatus enum in public API
// https://github.com/hashicorp/cloud-billing/blob/main/proto-public/hashicorp/cloud/billing_20201105/contract_service.proto
export const CONTRACT_STATUS = Object.freeze({
  ACTIVE: Billing20201105ContractStatus.ACTIVE,
  EXPIRED: Billing20201105ContractStatus.EXPIRED,
  UPCOMING: Billing20201105ContractStatus.UPCOMING,
  UNSET: Billing20201105ContractStatus.UNSET,
});
